import ContentWrapper from './ContentWrapper';
import LabeledHorizontal from '../../../components/raExtend/labels/LabeledHorizontal';
import MoneyField from '../../../components/raExtend/fields/MoneyField';
import { Offer } from '../types';
import { useRecordContext } from 'ra-core';

function Budget({ showStats }: { showStats: boolean }) {
  const offer = useRecordContext<Offer & { budget_remaining: number }>();

  if (!offer) return null;

  offer.budget_spent = offer.budget_spent || 0;
  offer.budget_remaining = offer.budget_total - offer.budget_spent;
  const spentRatio = offer.budget_spent / offer.budget_total;
  const percentage = Math.min(100, Math.max(0, spentRatio * 100));

  return (
    <ContentWrapper className="w-full">
      <LabeledHorizontal label="Total budget">
        <MoneyField<Offer> source="budget_total" />
      </LabeledHorizontal>
      {showStats && (
        <>
          <div className="w-full">
            <div className="flex justify-between text-xs text-muted-foreground mb-1">
              <span>{Math.round(percentage)}%</span>
            </div>
            <div className="h-2 w-full rounded-full bg-secondary overflow-hidden">
              <div
                className="h-full bg-violet-500 rounded-full transition-all"
                style={{ width: `${percentage}%` }}
              />
            </div>
          </div>
          <div className="flex gap-4">
            <LabeledHorizontal label="Budget spent">
              <MoneyField<Offer> source="budget_spent" />
            </LabeledHorizontal>
            <LabeledHorizontal label="Budget remaining">
              <MoneyField<typeof offer>
                source="budget_remaining"
                record={offer}
              />
            </LabeledHorizontal>
          </div>
        </>
      )}
    </ContentWrapper>
  );
}

export default Budget;
